import { render, staticRenderFns } from "./vuecommua11.vue?vue&type=template&id=3081eb54&scoped=true"
import script from "./vuecommua11.vue?vue&type=script&lang=js"
export * from "./vuecommua11.vue?vue&type=script&lang=js"
import style0 from "./vuecommua11.vue?vue&type=style&index=0&id=3081eb54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3081eb54",
  null
  
)

export default component.exports